import { Flex, useColorModeValue } from "@chakra-ui/react";

import { useGetThemeColors } from "ChakraTheme";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends IChildrenProp {}

const NavigationBar = ({ children }: IProps) => {
  const colors = useGetThemeColors();
  const backgroundColor = useColorModeValue(
    colors.primary[600],
    colors.primary[900]
  );

  return (
    <Flex
      display={{ base: "none", lg: "initial" }}
      borderBottomRightRadius={15}
      direction="column"
      backgroundColor={backgroundColor}
      textAlign="center"
      width={{
        base: "100%",
        lg: "300px",
      }}
      pb={4}
      maxH="800px"
      overflowY="auto"
    >
      {children}
    </Flex>
  );
};

export { NavigationBar };
